import React, { useEffect, useState } from 'react'
import {Tabs,Form,Input,InputNumber,Button,Checkbox,Tooltip, message} from 'antd'
import { SERVER_ADDRESS } from '../../Config/Config';
import axios from 'axios';
import { FaTrash } from 'react-icons/fa';
import { PlusCircleFilled } from '@ant-design/icons';
const { TextArea  } = Input
const PlanList = () => {
  const [plans,setPlans] = useState([]);
  const [dayForm] = Form.useForm();
  const [silver1Form] = Form.useForm();
  const [silver2Form] = Form.useForm();
  const [silver3Form] = Form.useForm();
  const [gold1Form] = Form.useForm();
  const [gold2Form] = Form.useForm();
  const [gold3Form] = Form.useForm();
  const [diamond1Form] = Form.useForm();
  const [diamond2Form] = Form.useForm();
  const [diamond3Form] = Form.useForm();

  const fetchPlanData = async()=>{
    try {
      const response = await axios.get(`${SERVER_ADDRESS}/api/getPlans`)
      if(response.status === 200){
        setPlans(response.data.data)
      }
    } catch (error) {
      message.error({content:"Something went wrong while fetcing plans"})
    }
  }

  useEffect(()=>{
    fetchPlanData();
  },[])

  const setFormValues = () =>{
    plans.map((plan)=>{
      const formData = {
        org_price:plan.org_price,
        discount:plan.discount,
        android_product_id:plan.android_product_id,
        ios_product_id:plan.ios_product_id,
        benefits: plan.benefits.map((b) => ({id:b.id,benefit:b.benefit,is_valid:b.is_valid})),
        is_recommend:plan.is_recommend
      };
      switch (plan.plan) {
        case 1:
            dayForm.setFieldsValue(formData)
          break;
        case 2:
            if(plan.duration === 1) silver1Form.setFieldsValue(formData)
            if(plan.duration === 3) silver2Form.setFieldsValue(formData)
            if(plan.duration === 6) silver3Form.setFieldsValue(formData)
          break
        case 3:
            if(plan.duration === 1) gold1Form.setFieldsValue(formData)
            if(plan.duration === 3) gold2Form.setFieldsValue(formData)
            if(plan.duration === 6) gold3Form.setFieldsValue(formData)
          break
        case 4:
            if(plan.duration === 1) diamond1Form.setFieldsValue(formData)
            if(plan.duration === 3) diamond2Form.setFieldsValue(formData)
            if(plan.duration === 6) diamond3Form.setFieldsValue(formData)
          break
        default:
          break;
      }
    })
  }

  useEffect(()=>{
    setFormValues()
  })

  const renderBenefitsFields = (name) => (
    <Form.List name={name}>
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) => (
            <div key={key} style={{ marginBottom: '16px',display:"flex",flexDirection:"row", width:"100%",gap:'3rem' }}>
              <Form.Item
                {...restField}
                name={[name, 'benefit']}
                label="Benefit"
                rules={[{ required: true, message: 'Enter Benefit' }]}
              >
                <TextArea placeholder="Enter Benefit" rows={2} style={{width:"20rem"}} />
              </Form.Item>
              <Form.Item
                {...restField}
                name={[name, 'is_valid']}
                valuePropName="checked"
              >
                <Checkbox>Is Valid</Checkbox>
              </Form.Item>
              <Tooltip title='Remove benefit' >
              <Button variant="filled" color='danger' onClick={() => remove(name)}>
                <FaTrash />
              </Button>
              </Tooltip>
            </div>
          ))}
          <div style={{display:'flex',width:"25%",justifyContent:'center',alignItems:"center"}} >
          <Tooltip title='Add benefit' >
          <Button variant='filled' color='primary' onClick={() => add()} block>
            <PlusCircleFilled />
          </Button>
          </Tooltip>
          </div>
        </>
      )}
    </Form.List>
  );

  const handePlanSubmit = async(form,planId,duration) =>{
    try {
      const values = await form.validateFields();
      const response = await axios.post(`${SERVER_ADDRESS}/api/updatePlans`,{
        plan_id: planId,
        duration: duration,
        org_price: values.org_price,
        discount: values.discount,
        android_product_id: values.android_product_id,
        ios_product_id: values.ios_product_id,
        benefits: values.benefits,
        is_recommend: values.is_recommend,
      })
      if(response.status === 200){
        message.success({content:"Plan Updated Successfully"})
      }
    } catch (error) {
      if(error.response.status === 404){
        message.error({content:`${error.response.data.message}`})
      }
      else{
        message.error({content:"Something Went Wrong on Updating plans"})
      }
    }
  }

  const silverItems = [ 
    {
      label:"1 Month",
      key:"1",
      children:(
        <div className='bg-white' >
        <div style={{padding:"4rem"}} >
        <Form labelCol={{span:3}} wrapperCol={{span:14}} key={'silver1'} onFinish={()=>{handePlanSubmit(silver1Form,2,1)}} form={silver1Form}>
          <Form.Item label='Original Price' name='org_price' rules={[{required:true,message:"Enter Original Price"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Discount' name='discount' rules={[{required:true,message:"Enter discount"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Android Product ID' wrapperCol={{ span: 6 }} name='android_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter Android Product Id' />
          </Form.Item>
          <Form.Item label='IOS Product ID' wrapperCol={{ span: 6 }} name='ios_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter IOS Product Id' />
          </Form.Item>
          <Form.Item label='Benefits' >
            {renderBenefitsFields('benefits')}
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }} name='is_recommend' valuePropName='checked' >
            <Checkbox>Is Recommend</Checkbox>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }}>
            <Button type='primary' htmlType='submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
        </div>
        </div>
      )
    },
    {
      label:"3 Month",
      key:"3",
      children:(
        <div className='bg-white' >
        <div style={{padding:"4rem"}} >
        <Form labelCol={{span:3}} wrapperCol={{span:14}} key={'silver2'} onFinish={()=>{handePlanSubmit(silver2Form,2,3)}} form={silver2Form}>
          <Form.Item label='Original Price' name='org_price' rules={[{required:true,message:"Enter Original Price"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Discount' name='discount' rules={[{required:true,message:"Enter discount"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Android Product ID' wrapperCol={{ span: 6 }} name='android_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter Android Product Id' />
          </Form.Item>
          <Form.Item label='IOS Product ID' wrapperCol={{ span: 6 }} name='ios_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter IOS Product Id' />
          </Form.Item>
          <Form.Item label='Benefits' >
            {renderBenefitsFields('benefits')}
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }} name='is_recommend' valuePropName='checked' >
            <Checkbox>Is Recommend</Checkbox>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }}>
            <Button type='primary' htmlType='submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
        </div>
        </div>
      )
    },
    {
      label:"6 Month",
      key:"6",
      children:(
        <div className='bg-white' >
        <div style={{padding:"4rem"}} >
        <Form labelCol={{span:3}} wrapperCol={{span:14}} key={'silver1'} onFinish={()=>{handePlanSubmit(silver3Form,2,6)}} form={silver3Form}>
          <Form.Item label='Original Price' name='org_price' rules={[{required:true,message:"Enter Original Price"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Discount' name='discount' rules={[{required:true,message:"Enter discount"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Android Product ID' wrapperCol={{ span: 6 }} name='android_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter Android Product Id' />
          </Form.Item>
          <Form.Item label='IOS Product ID' wrapperCol={{ span: 6 }} name='ios_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter IOS Product Id' />
          </Form.Item>
          <Form.Item label='Benefits' >
            {renderBenefitsFields('benefits')}
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }} name='is_recommend' valuePropName='checked' >
            <Checkbox>Is Recommend</Checkbox>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }}>
            <Button type='primary' htmlType='submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
        </div>
        </div>
      )
    }
  ]
  const goldItems = [
    {
      label:"1 Month",
      key:"1",
      children:(
        <div className='bg-white' >
        <div style={{padding:"4rem"}} >
        <Form labelCol={{span:3}} wrapperCol={{span:14}} key={'gold1'} onFinish={()=>{handePlanSubmit(gold1Form,3,1)}} form={gold1Form}>
          <Form.Item label='Original Price' name='org_price' rules={[{required:true,message:"Enter Original Price"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Discount' name='discount' rules={[{required:true,message:"Enter discount"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Android Product ID' wrapperCol={{ span: 6 }} name='android_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter Android Product Id' />
          </Form.Item>
          <Form.Item label='IOS Product ID' wrapperCol={{ span: 6 }} name='ios_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter IOS Product Id' />
          </Form.Item>
          <Form.Item label='Benefits' >
            {renderBenefitsFields('benefits')}
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }} name='is_recommend' valuePropName='checked' >
            <Checkbox>Is Recommend</Checkbox>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }}>
            <Button type='primary' htmlType='submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
        </div>
        </div>
      )
    },
    {
      label:"3 Month",
      key:"3",
      children:(
        <div className='bg-white' >
        <div style={{padding:"4rem"}} >
        <Form labelCol={{span:3}} wrapperCol={{span:14}} key={'gold2'} onFinish={()=>{handePlanSubmit(gold2Form,3,3)}}  form={gold2Form}>
          <Form.Item label='Original Price' name='org_price' rules={[{required:true,message:"Enter Original Price"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Discount' name='discount' rules={[{required:true,message:"Enter discount"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Android Product ID' wrapperCol={{ span: 6 }} name='android_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter Android Product Id' />
          </Form.Item>
          <Form.Item label='IOS Product ID' wrapperCol={{ span: 6 }} name='ios_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter IOS Product Id' />
          </Form.Item>
          <Form.Item label='Benefits' >
            {renderBenefitsFields('benefits')}
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }} name='is_recommend' valuePropName='checked' >
            <Checkbox>Is Recommend</Checkbox>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }}>
            <Button type='primary' htmlType='submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
        </div>
        </div>
      )
    },
    {
      label:"6 Month",
      key:"6",
      children:(
        <div className='bg-white' >
        <div style={{padding:"4rem"}} >
        <Form labelCol={{span:3}} wrapperCol={{span:14}} key={'gold3'} onFinish={()=>{handePlanSubmit(gold3Form,3,6)}}  form={gold3Form}>
          <Form.Item label='Original Price' name='org_price' rules={[{required:true,message:"Enter Original Price"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Discount' name='discount' rules={[{required:true,message:"Enter discount"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Android Product ID' wrapperCol={{ span: 6 }} name='android_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter Android Product Id' />
          </Form.Item>
          <Form.Item label='IOS Product ID' wrapperCol={{ span: 6 }} name='ios_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter IOS Product Id' />
          </Form.Item>
          <Form.Item label='Benefits' >
            {renderBenefitsFields('benefits')}
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }} name='is_recommend' valuePropName='checked' >
            <Checkbox>Is Recommend</Checkbox>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }}>
            <Button type='primary' htmlType='submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
        </div>
        </div>
      )
    }
  ]
  const diamondItems = [
    {
      label:"1 Month",
      key:"1",
      children:(
        <div className='bg-white' >
        <div style={{padding:"4rem"}} >
        <Form labelCol={{span:3}} wrapperCol={{span:14}} key={'diamond1'} onFinish={()=>{handePlanSubmit(diamond1Form,4,1)}}  form={diamond1Form}>
          <Form.Item label='Original Price' name='org_price' rules={[{required:true,message:"Enter Original Price"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Discount' name='discount' rules={[{required:true,message:"Enter discount"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Android Product ID' wrapperCol={{ span: 6 }} name='android_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter Android Product Id' />
          </Form.Item>
          <Form.Item label='IOS Product ID' wrapperCol={{ span: 6 }} name='ios_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter IOS Product Id' />
          </Form.Item>
          <Form.Item label='Benefits' >
            {renderBenefitsFields('benefits')}
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }} name='is_recommend' valuePropName='checked' >
            <Checkbox>Is Recommend</Checkbox>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }}>
            <Button type='primary' htmlType='submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
        </div>
        </div>
      )
    },
    {
      label:"3 Month",
      key:"3",
      children:(
        <div className='bg-white' >
        <div style={{padding:"4rem"}} >
        <Form labelCol={{span:3}} wrapperCol={{span:14}} key={'diamond2'} onFinish={()=>{handePlanSubmit(diamond2Form,4,3)}} form={diamond2Form}>
          <Form.Item label='Original Price' name='org_price' rules={[{required:true,message:"Enter Original Price"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Discount' name='discount' rules={[{required:true,message:"Enter discount"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Android Product ID' wrapperCol={{ span: 6 }} name='android_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter Android Product Id' />
          </Form.Item>
          <Form.Item label='IOS Product ID' wrapperCol={{ span: 6 }} name='ios_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter IOS Product Id' />
          </Form.Item>
          <Form.Item label='Benefits' >
            {renderBenefitsFields('benefits')}
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }} name='is_recommend' valuePropName='checked' >
            <Checkbox>Is Recommend</Checkbox>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }}>
            <Button type='primary' htmlType='submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
        </div>
        </div>
      )
    },
    {
      label:"6 Month",
      key:"6",
      children:(
        <div className='bg-white' >
        <div style={{padding:"4rem"}} >
        <Form labelCol={{span:3}} wrapperCol={{span:14}} key={'diamond3'} onFinish={()=>{handePlanSubmit(diamond3Form,4,6)}} form={diamond3Form}>
          <Form.Item label='Original Price' name='org_price' rules={[{required:true,message:"Enter Original Price"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Discount' name='discount' rules={[{required:true,message:"Enter discount"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Android Product ID' wrapperCol={{ span: 6 }} name='android_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter Android Product Id' />
          </Form.Item>
          <Form.Item label='IOS Product ID' wrapperCol={{ span: 6 }} name='ios_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter IOS Product Id' />
          </Form.Item>
          <Form.Item label='Benefits' >
            {renderBenefitsFields('benefits')}
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }} name='is_recommend' valuePropName='checked' >
            <Checkbox>Is Recommend</Checkbox>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }}>
            <Button type='primary' htmlType='submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
        </div>
        </div>
      )
    }
  ]
  const items = [
    {
      label:"Day Plan",
      key:"1",
      children:(
        <div className='bg-white' >
        <div style={{padding:"4rem"}} >
        <Form labelCol={{span:3}} wrapperCol={{span:14}} form={dayForm} key={'day'} onFinish={()=>{handePlanSubmit(dayForm,1,1)}} >
          <Form.Item label='Original Price' name='org_price' rules={[{required:true,message:"Enter Original Price"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Discount' name='discount' rules={[{required:true,message:"Enter discount"}]} >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label='Android Product ID' wrapperCol={{ span: 6 }} name='android_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter Android Product Id' />
          </Form.Item>
          <Form.Item label='IOS Product ID' wrapperCol={{ span: 6 }} name='ios_product_id' rules={[{required:true,message:"Enter Product Id"}]} >
            <Input placeholder='Enter IOS Product Id' />
          </Form.Item>
          <Form.Item label='Benefits' >
            {renderBenefitsFields('benefits')}
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }} name='is_recommend' valuePropName='checked' >
            <Checkbox>Is Recommend</Checkbox>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 3 }}>
            <Button type='primary' htmlType='submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
        </div>
        </div>
      )
    },
    {
      label:"Silver Plan",
      key:"2",
      children:(
        <Tabs centered items={silverItems} />
      )
    },
    {
      label:"Gold Plan",
      key:"3",
      children:(
        <Tabs centered items={goldItems} />
      )
    },
    {
      label:"Diamond Plan",
      key:"4",
      children:(
        <Tabs centered items={diamondItems} />
      )
    }
  ]
  return (
    <>
      <div style={{marginTop:"4rem"}} > 
        <Tabs defaultActiveKey='1' centered items={items} />
      </div>
    </>
  )
}

export default PlanList